import * as React from 'react';
import type { IconProps } from '../icon-prop-types';

export const HandleIcon = ({ fill = 'coolGreyDark' }: IconProps) => {
    return (
        <svg
            width="9px"
            height="15px"
            viewBox="0 0 9 15"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>Group 3 Copy 3</title>
            <g id="Setting-Starting-LIneup" stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
                <g id="SSLU---Set-DH---Mobile-4" transform="translate(-48.000000, -919.000000)" fill={fill}>
                    <g id="Group-3-Copy-3" transform="translate(48.000000, 919.000000)">
                        <rect id="Rectangle" x="0" y="0" width="3" height="3"></rect>
                        <rect id="Rectangle-Copy-12" x="0" y="6" width="3" height="3"></rect>
                        <rect id="Rectangle-Copy-14" x="0" y="12" width="3" height="3"></rect>
                        <rect id="Rectangle-Copy-11" x="6" y="0" width="3" height="3"></rect>
                        <rect id="Rectangle-Copy-13" x="6" y="6" width="3" height="3"></rect>
                        <rect id="Rectangle-Copy-15" x="6" y="12" width="3" height="3"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};
